export enum EAcquirerService {
  unknown = 1,
  cryptoCloud = 2,
  paypal = 3,
  dodoPayments = 4,
  visa2Pay = 5,
}
